import { Map } from 'immutable'
import { combineReducers } from 'redux'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'


const appInfo = handleActions(
  {
    [combineActions(actions.fetchOAuthAppInfoSuccess)]: (state, action) => {
      return state.set(action.payload.client_id, action.payload.app)
    }
  },
  Map()
)

const status = handleActions(
  {
    [combineActions(actions.fetchOAuthAppInfoFailed,actions.fetchOAuthAppInfoPending, actions.fetchOAuthAppInfoSuccess)]: (state, action) => {
      return state.setIn(['appInfo', action.payload.client_id], action.type)
    },
    [combineActions(actions.fetchOAuthCodeFailed,
      actions.fetchOAuthCodePending, actions.fetchOAuthCodeSuccess)]: (state, action) => {
        return state.setIn(['appCode', action.payload.client_id], action.type)
      },
  },
  Map()
)

const appCodes = handleActions(
  {
    [combineActions(actions.fetchOAuthCodeSuccess)]: (state, action) => {
      return state.set(action.payload.client_id, action.payload.code)
    },
  },
  Map()
)

export default combineReducers({
  appInfo,
  appCodes,
  status
})


// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/reducer.js